import React from "react";
import { Button, Typography, Grid, Box } from "@mui/material";
import { styled } from "@mui/system";
import Link from "@mui/material/Link";
import { useTheme } from "@mui/material/styles";
// import { redirect } from "react-router-dom";

import {
  primaryTxt,
  secondaryTxt,
  secondaryBg,
  primaryBg,
  buttonBg,
} from "../constants/colors";

// const theme = useTheme();
const FactsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: secondaryBg,
  width: "100vw",
  padding: "3em",
  boxSizing: "border-box",
  [theme.breakpoints.down("sm")]: {
    padding: "2em",
  },
}));

const FactsImage = styled("img")({
  height: "auto",
  width: "100%",
  // maxWidth: "350px",
  maxHeight: "350px",
  objectFit: "cover",
  borderRadius: "4%",
});

const FactsDetails = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  padding: "3em",
  [theme.breakpoints.down("sm")]: {
    padding: "1em",
  },
}));

const FactsTitle = styled(Typography)({
  fontFamily: "Roboto Slab",
  fontWeight: "600",
  color: primaryTxt,
});

const FactsDesc = styled(Typography)({
  fontFamily: "Roboto Slab",
  fontWeight: "400",
  marginTop: "12px",
  color: secondaryTxt,
});

const FactsButton = styled(Button)(({ theme }) => ({
  marginTop: "12px",
  width: "fit-content",
  color: primaryTxt,
  backgroundColor: buttonBg,
}));

const FactsSection = ({
  id,
  imageSrc,
  title,
  description,
  buttonText,
  buttonLink,
  reverse,
}) => {
  return (
    <FactsContainer id={id || ""}>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6} order={{ xs: 1, md: reverse ? 2 : 1 }}>
          <FactsImage src={imageSrc} />
        </Grid>
        <Grid item xs={12} md={6} order={{ xs: 2, md: reverse ? 1 : 2 }}>
          <FactsDetails>
            <FactsTitle variant="h3">{title}</FactsTitle>
            <FactsDesc variant="h5">{description}</FactsDesc>
            <Link href={buttonLink} target="_blank" rel="noopener">
              <FactsButton variant="contained">{buttonText}</FactsButton>
            </Link>
          </FactsDetails>
        </Grid>
      </Grid>
    </FactsContainer>
  );
};

export default FactsSection;
